import * as React from "react";
import ChevronPanel from "source/app/presentation/Shared/ChevronPanel/ChevronPanel";
import { GetActiveDreamHashTags } from "source/app/presentation/MainPanel/Dreams/HashTags/Helpers/GetActiveDreamHashTags";
import { HashTagOptions } from "./HashTagOptions";

export function HashTagOptionsChevronPanel() {
    const activeHashTags = GetActiveDreamHashTags();

    if (activeHashTags.length === 0) {
        return null;
    }

    const hashTag = activeHashTags[0];

    return (
        <div>
            <ChevronPanel
                id="hashTagOptionsChevronPanel"
                label="HashTag options"
            >
                <HashTagOptions {...{ hashTag }} />
            </ChevronPanel>
        </div>
    );
}


